import styled from 'styled-components';
const SearchGroupStyled = styled.div`
  background-color: #fff;
  border-radius: 12px;

  .search-wrapper {
    display: flex;
  }
  padding: 24px 32px 32px;

  .left {
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .button-group {
    height: 100%;
    margin-left: 64px;
    display: flex;
    .reset {
      margin-right: 24px;
    }
    .search {
      margin-right: 0;
    }
  }
  .first-line {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    gap: 48px;
    .campaignName {
      width: 200px;
    }
    .date {
      width: 312px;
    }
    .status {
      width: 112px;
    }
  }
`;
export default SearchGroupStyled;
